import { useEffect, type ReactNode } from 'react'
import { useUIStore } from '@/stores/uiStore'

/**
 * Syncs `document.documentElement`'s `theme-<id>` class to the
 * current store value. The initial class is set pre-React by an
 * inline script in `index.html` so there's no first-paint flash.
 * This effect only matters when the user switches themes at runtime.
 */
export function ThemeProvider({ children }: { children: ReactNode }) {
  const theme = useUIStore(s => s.theme)

  useEffect(() => {
    const el = document.documentElement
    // Drop any previous theme-* class so switching doesn't stack.
    el.className = el.className.replace(/\btheme-[a-z-]+\b/g, '').trim()
    el.classList.add(`theme-${theme}`)
    // All four themes are dark — keep the `dark` class permanent so
    // existing `dark:*` Tailwind utilities (pre-dating this theme
    // system) continue rendering correctly.
    el.classList.add('dark')
  }, [theme])

  return <>{children}</>
}
